export enum LoseType {
    NoVegetablesLeft,
    Dead
}
